import React from 'react';
import { IOuter } from './UnsplashHelpLink.types';
import { HELP_LINKS } from '../../../constants/HelpLinks';
import { FormattedMessage } from 'react-intl';

export const UnsplashHelpLinkComponent: React.FC<IOuter> = ({ messageId, onClick }) => (
  <a target="_blank" href={HELP_LINKS.UNSPLASH_TERMS} onClick={onClick} rel="noreferrer">
    <FormattedMessage id={messageId} />
  </a>
);
